export default __webpack_public_path__ + "static/media/coop-pms-295.00746227.jpg";